var positions = {};
var currentPosition = 0;

/**
 * Calculates the number of positions in the carousel and indexes them to positions
 * 
 * @param {number} numberOfPositions - Number of positions in the carousel
 * @param {number} size - Total size of each unit in the carousel including margins
 * @return {object} object containing all of the positions on the carousel
 */
export function setPositions(numberOfPositions, size) {
    for (var i = 0; i < numberOfPositions; i++) {
        positions[i] = (size * i); 
    }
    return positions;
}

/**
 * Gets the value for any given position on the carousel
 * 
 * @param {number} position - Position being queried
 * @returns {number} Position, in pixels, of the requested position on the carousel.
 */
export function getPosition(position) {
    if (positions[position] || position === 0) {
        return positions[position];
    } 
}

/**
 * Resets current position to 0
 * 
 * @param {string} containerSelector - A string representing a css selector for the target carousel
 * @returns {number} Current position of the carousel
 */
export function resetCarousel(containerSelector) {
    currentPosition = 0;
    $(containerSelector).css('transform', '');
    return currentPosition;
}

/**
 * Moves the carousel by the number of cards visible. E.g. If the user's screen is showing 3 whole cards and 1 partial
 * card, it will move by 3 cards. If the user resizes to the screen showing 1 whole card and 1 partial card, it will
 * move by 1 card.
 * 
 * @param {selector} containerSelector - Selector for the div containing the whole carousel
 * @param {boolean} moveForward - Any truthy value will move the carousel forward, falsey values will move it backward
 * @returns {number} current position of the carousel
 */
export function moveCarousel(containerSelector, moveForward) {
    /* 
    * positions[1] is the total card width including margins, etc. and is used to calculate how many _total_ cards can be
    * shown at once.
    */
    let visibleCardSlots = Math.floor(($(containerSelector).parents('.carousel-container').width() - $('.carousel-button').width() * 2) / positions[1]);
    let newPosition = moveForward ? currentPosition + visibleCardSlots : currentPosition - visibleCardSlots;
    newPosition = newPosition < 0 ? 0 : newPosition;
    // prevents scrolling past the last visible slot
    let maximumLeftScroll = Object.keys(positions).length;
    let maximumTransform = positions[Object.keys(positions).length - visibleCardSlots]
    if (newPosition < maximumLeftScroll) {
        let transform = getPosition(newPosition);
        $(containerSelector).css('transform', `translateX(-${transform < maximumTransform ? transform : maximumTransform}px)`);
        currentPosition = newPosition;
    }
    return currentPosition;
}


// WEBPACK FOOTER //
// ../D:/builds/ACES/Pharmacy Compass Production Support/PharmacyCompass2/Content/scripts/carousel.js